import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import type { Violation, CompiledStyleRule } from './validation.types'

export function useStyleCheck(
  text: string,
  compiledRules: CompiledStyleRule[] | undefined,
): Violation[] {
  const { t } = useTranslation()
  return useMemo(() => {
    if (!compiledRules?.length || !text) return []
    const violations: Violation[] = []
    for (const r of compiledRules) {
      const re = new RegExp(r.regex.source, r.regex.flags)
      if (re.test(text)) {
        violations.push({
          type: 'style',
          severity: r.severity,
          message: t(`remake.styleRule.${r.rule}`, r.rule),
        })
      }
    }
    return violations
  }, [text, compiledRules, t])
}
